import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { INPUT } from '../../../constants';
import { useInput } from '../../../hooks';
import { Context } from '../Context';
const Input = forwardRef((props, ref) => {
    const context = useContext(Context);
    const { inputProps, inputA11yProps } = useInput(context);
    return _jsx("input", { ref: ref, ...inputProps, ...inputA11yProps, ...props });
});
Input.displayName = INPUT;
export { Input };
//# sourceMappingURL=Input.js.map